import axios from "axios";

const STORAGE_KEY = "geo_location_cache_v1";
const STORAGE_TTL_MS = 24 * 60 * 60 * 1000; // 24 hours

let inFlightRequest: Promise<any> | null = null;

function readCachedLocation(): any | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !parsed.timestamp || !parsed.data) return null;
    const isFresh = Date.now() - parsed.timestamp < STORAGE_TTL_MS;
    return isFresh ? parsed.data : null;
  } catch (_err) {
    return null;
  }
}

function writeCachedLocation(data: any): void {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ timestamp: Date.now(), data })
    );
  } catch (_err) {
    // Ignore storage errors (quota/private mode)
  }
}

const getLocationAsync = async () => {
  const cached = readCachedLocation();
  if (cached) return cached;

  if (inFlightRequest) return inFlightRequest;

  const apiKey = process.env.REACT_APP_IPGEO_KEY || "6032512ed21b4cd88676a8ae5a93a4f8";
  const url = `https://api.ipgeolocation.io/ipgeo?apiKey=${apiKey}`;

  inFlightRequest = axios
    .get(url)
    .then((response) => {
      writeCachedLocation(response.data);
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      return null;
    })
    .finally(() => {
      inFlightRequest = null;
    });

  return inFlightRequest;
};

export default getLocationAsync;
